import { render, staticRenderFns } from "./RatingStatItem.vue?vue&type=template&id=1c12b338&scoped=true&"
import script from "./RatingStatItem.vue?vue&type=script&lang=ts&setup=true&"
export * from "./RatingStatItem.vue?vue&type=script&lang=ts&setup=true&"
import style0 from "./RatingStatItem.vue?vue&type=style&index=0&id=1c12b338&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c12b338",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1c12b338')) {
      api.createRecord('1c12b338', component.options)
    } else {
      api.reload('1c12b338', component.options)
    }
    module.hot.accept("./RatingStatItem.vue?vue&type=template&id=1c12b338&scoped=true&", function () {
      api.rerender('1c12b338', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/pages/[town-translit]/lpu/[lpu-translit]/_components/LpuRating/components/RatingStatItem.vue"
export default component.exports